module.exports = __webpack_public_path__ + "static/media/Yellow.ai ( Logo)  (1).a1565af2.jpg";